export default __webpack_public_path__ + "static/media/new-icon-subscription-fill.65ef97a0.svg";